var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#57454A",
    viewBox: "0 -2 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.041 21.8755C42.041 10.0001 32.6402 0.375488 21.041 0.375488C9.4418 0.375488 0.0410156 10.0001 0.0410156 21.8755C0.0410156 31.9536 6.825 40.4192 15.9715 42.7456V28.4431H11.6402V21.8755H15.9715V19.0452C15.9715 11.7302 19.2035 8.33721 26.2254 8.33721C27.5543 8.33721 29.8512 8.60596 30.7945 8.87471V14.8208C30.3023 14.7704 29.441 14.7368 28.3664 14.7368C24.9211 14.7368 23.5922 16.0722 23.5922 19.5407V21.8755H30.45L29.2687 28.4431H23.584V43.2159C33.9855 41.931 42.041 32.869 42.041 21.8755Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.86b9819ec0aada47db075a70c7fd04c2.svg";
export { ForwardRef as ReactComponent };